




































































































































































































































import {
  ComponentInternalInstance,
  getCurrentInstance,
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { CheckCircleFilledIcon, CloseCircleFilledIcon, FileCopyIcon } from 'tdesign-icons-vue';
import _ from 'lodash';
import RemoveConfigConfirm from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/RemoveConfigConfirm.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import { formatError } from '@/renderer/scripts/utils/errorCode/index';
import { httpUrl, CONSTANT_URL, HttpUrl } from '@/renderer/scripts/http';
import { copyText2Clipboard } from '@/renderer/scripts/utils/tools/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';

type WeworkConfigParams = SMH.WeworkConfigParams & {
  [key: string]: string | boolean | number | undefined;
};

export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    initData: {
      required: false,
      type: Object,
      default: {
        corpid: '',
        agentId: 0,
        secret: '',
        autoOrgSyncEnabled: false,
      },
    },
  },
  components: {
    CheckCircleFilledIcon,
    CloseCircleFilledIcon,
    FileCopyIcon,
    RemoveConfigConfirm,
  },
  filters: {
    ConfigFormValidateFormatter(code: string) {
      const format: Record<string, string> = {
        success: i18n_t('配置生效'),
        error: i18n_t('配置失败'),
        none: i18n_t('未配置'),
      };
      return format[code];
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;

    // 可信域名
    const trustedDomain = store.getters.isPrivate ? httpUrl.webHost : 'pan.tencent.com';

    // 非企业版屏蔽功能按钮
    const featureNotSupported = computed(() => store.getters.editionFlag !== 'enterprise');
    const weworkConfig = reactive<WeworkConfigParams>({
      corpid: '',
      agentId: 0,
      secret: '',
      autoOrgSyncEnabled: false,
    });
    const configFormTips = reactive({
      corpid: '',
      agentId: '',
      secret: '',
      validate: {
        code: 'none',
        message: i18n_t('未配置'),
      },
    });
    const showModifyPage = ref(false);
    const currentStep = ref(0);
    /**
     * 配置条件未完成
     */
    const configUnFinished = computed(() => {
      const allow =
        weworkConfig.corpid &&
        weworkConfig.agentId &&
        weworkConfig.secret &&
        configFormTips.corpid === '' &&
        configFormTips.agentId === '' &&
        configFormTips.secret === '';
      return !allow;
    });

    // 绑定数据
    const showWeworkAppLink = ref(store.getters.showWeworkAppLink);
    const weworkAppLink = computed(() => {
      /**
       * 限制公有云下只能跳转pan.tencent.com,由前端根据envDomain跳转到指定环境
       */
      // prefix 自定义域名前缀
      const prefix = store.getters.domains.length > 0 ? store.getters.domains[0].domain.replace('.cofile.net', '') : '';
      const env = HttpUrl.getCurrentEnv();
      let envDomain = 'pan.tencent.com';
      // 非线上环境需要跳转到domain比如test.pan.tencent.com；线上环境本身就在pan.tencent.com域名下，domain置空即不需要再跳转
      let domain = `${store.getters.protocol}://${envDomain}`;
      // 非线上环境 需要二跳到envDomain
      if (['dev', 'test', 'pre'].includes(env)) {
        envDomain = `${env}.pan.tencent.com`;
      }
      const secondRedirectDomain = [prefix, envDomain].filter(v => v).join('.');
      let origin = `${store.getters.protocol}://${CONSTANT_URL.defaultDomain}`;
      // 私有化下不需要二跳（二跳指公有云下第一跳必须是pan.tencent.com域名 二跳到domain对应的域名）
      if (store.getters.isPrivate) {
        domain = '';
        origin = httpUrl.webUrl;
      }
      const realdomain = `${secondRedirectDomain}`;
      const pathname = '/login';
      const redirectUrl = encodeURIComponent(
        `${origin}/login?domain=${domain}&realdomain=${realdomain}&path=${pathname}`,
      );

      const state = `wwlogin_${new Date().getTime()}`;
      return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${weworkConfig.corpid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`;
    });
    const methods = {
      init() {
        currentStep.value = 0;
        configFormTips.corpid = '';
        configFormTips.agentId = '';
        configFormTips.secret = '';
        configFormTips.validate = {
          code: 'none',
          message: i18n_t('未关联'),
        };
        if (!props.initData.corpid || !props.initData.agentId || !props.initData.secret) {
          showModifyPage.value = true;
        } else {
          showModifyPage.value = false;
        }
        Object.assign(weworkConfig, props.initData);
      },
      validateConfigForm(type: string) {
        switch (type) {
          case 'corpid':
            configFormTips.corpid =
              (weworkConfig.corpid as string).length < 5 || (weworkConfig.corpid as string).length > 30
                ? i18n_t('长度在5-30之间')
                : '';
            break;
          case 'agentId':
            {
              const regex = /^\d+$/;
              if (
                !regex.test(String(weworkConfig.agentId)) ||
                (regex.test(String(weworkConfig.agentId)) && (weworkConfig.agentId as number) > 1000000000)
              ) {
                configFormTips.agentId = i18n_t('请输入整数，且值在0-1000000000之间');
              } else {
                configFormTips.agentId = '';
              }
            }
            break;
          case 'secret':
            configFormTips.secret =
              (weworkConfig.secret as string).length < 10 || (weworkConfig.secret as string).length > 65
                ? i18n_t('长度在10-65之间')
                : '';
            break;
          default:
            break;
        }
      },
      throttleValidateConfigForm: _.throttle((type: string) => {
        showWeworkAppLink.value = false;
        const isDiff = ['corpid', 'agentId', 'secret'].some(key => weworkConfig[key] !== props.initData[key]);
        if (isDiff) {
          configFormTips.validate.code = 'none'; // 有改动清除测试结果
        }

        methods.validateConfigForm(type);
      }, 500),
      async configFormCheck(notips?: boolean) {
        try {
          await smh.userAPI.checkWeworkConfig({
            ...weworkConfig,
          });
          configFormTips.validate.code = 'success';
          configFormTips.validate.message = i18n_t('配置生效');
          showWeworkAppLink.value = true;
          !notips && tips.success(i18n_t('测试成功'));
        } catch (error) {
          configFormTips.validate.code = 'error';
          configFormTips.validate.message = i18n_t('配置失败，{slot1}', {
            slot1: formatError(error as MsgError),
          });
          showWeworkAppLink.value = false;
          tips.error(error as MsgError);
        }
      },
      modifyAssociation() {
        showModifyPage.value = true;
      },
      goToPreviousStep() {
        currentStep.value = 0;
      },
      async goToNextStep() {
        // await methods.configFormCheck();
        currentStep.value = 1;
      },
      copyText(url: string) {
        copyText2Clipboard(url)
          .then(() => {
            tips.success(i18n_t('复制成功'));
          })
          .catch(() => {
            tips.success(i18n_t('复制失败'));
          });
      },
      async finishConfig() {
        try {
          await smh.userAPI.updateWeworkConfig({
            ...weworkConfig,
          });
          context.emit('onSubmit', {
            ...weworkConfig,
          });
          innerShow.value = false;
        } catch (error) {
          tips.error(error as MsgError);
        }
      },
      openCofileGuide() {
        dispatchRouter(httpUrl.staticCDNURLMap.userManualUrl);
      },
      onClose() {
        innerShow.value = false;
      },
      removeConfirm() {
        methods.onClose();
        context.emit('refresh', 'wework');
      },
    };
    watch(innerShow, () => {
      if (innerShow.value) {
        methods.init();
      }
    });
    return {
      innerShow,
      trustedDomain,
      showModifyPage,
      currentStep,
      featureNotSupported,
      weworkConfig,
      configFormTips,
      configUnFinished,
      showWeworkAppLink,
      weworkAppLink,
      ...methods,
    };
  },
});
